import { useQuery } from "@apollo/client";

import { MY_MOD_PROFILE } from "../queries";

const useMyPhotoModProfile = () => {
    let modProfile;

    const { data } = useQuery(MY_MOD_PROFILE);

    if (data) {
        modProfile = data.profile;
    }

    return modProfile;
};

export default useMyPhotoModProfile;
